import { render } from "./StoreElementView.vue?vue&type=template&id=231723dc&scoped=true&ts=true"
import script from "./StoreElementView.vue?vue&type=script&lang=ts"
export * from "./StoreElementView.vue?vue&type=script&lang=ts"

import "./StoreElementView.vue?vue&type=style&index=0&id=231723dc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231723dc"]])

export default __exports__